import { createSlice } from "@reduxjs/toolkit";

const priceSlice = createSlice({
    name: "price",
    initialState: {
        priceData: null,
        isGetPriceLoading: false,

        singlePriceData: null,
        isGetPriceByIdLoading: false,

        isUpdatePriceLoading: false,
        isCreatePriceLoading: false,

    },
    reducers: {
        getPriceLoading: (state) => {
            state.isGetPriceLoading = true;
        },
        getPriceSuccess: (state, action) => {
            state.priceData = action.payload;
            state.isGetPriceLoading = false;
        },
        getPriceFailure: (state) => {
            state.isGetPriceLoading = false;
        },
        // // update
        updatePriceLoading: (state) => {
            state.isUpdatePriceLoading = true;
        },
        updatePriceSuccess: (state, action) => {
            state.priceData = action.payload;
            state.isUpdatePriceLoading = false;
        },
        updatePriceFailure: (state) => {
            state.isUpdatePriceLoading = false;
        },

        // get by id
        getPriceByIdLoading: (state) => {
            state.isGetPriceLoading = true;
        },
        getPriceByIdSuccess: (state, action) => {
            state.singlePriceData = action.payload;
            state.isGetPriceLoading = false;
        },
        getPriceByIdFailure: (state) => {
            state.isGetPriceLoading = false;
        },

        // create
        createPriceLoading: (state) => {
            state.isCreatePriceLoading = true;
        },
        createPriceSuccess: (state, action) => {
            state.priceData = action.payload;
            state.isCreatePriceLoading = false;
        },
        createPriceFailure: (state) => {
            state.isCreatePriceLoading = false;
        },

    }
});

export const {
    getPriceLoading,
    getPriceSuccess,
    getPriceFailure,

    getPriceByIdLoading,
    getPriceByIdSuccess,
    getPriceByIdFailure,

    updatePriceLoading,
    updatePriceSuccess,
    updatePriceFailure,

    createPriceLoading,
    createPriceSuccess,
    createPriceFailure,

} = priceSlice.actions;

export default priceSlice.reducer;